import axios from "axios";

const KEY = "lead_attr";
const TTL = 30 * 24 * 3600 * 1000;
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid", "msclkid", "ttclid"];

// Cattura codici campagna e sito di provenienza; restano validi 30 giorni (ultimo contatto non diretto).
export function captureAttribution() {
  try {
    const qs = new URLSearchParams(window.location.search);
    const a = {};
    PARAMS.forEach((p) => { if (qs.get(p)) a[p] = qs.get(p); });
    const ref = document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : "";
    if (ref) a.referrer = ref;
    if (Object.keys(a).length) {
      a.landing = window.location.pathname;
      a.ts = Date.now();
      localStorage.setItem(KEY, JSON.stringify(a));
    }
    const saved = JSON.parse(localStorage.getItem(KEY) || "null");
    if (saved && Date.now() - (saved.ts || 0) > TTL) localStorage.removeItem(KEY);
  } catch { /* storage non disponibile */ }
}

export function attributionHeader() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? btoa(unescape(encodeURIComponent(raw))) : null;
  } catch { return null; }
}

export function installAttribution(instances) {
  captureAttribution();
  [axios, ...instances].forEach((inst) => inst.interceptors.request.use((config) => {
    const h = attributionHeader();
    if (h && /\/(self\/start|public\/quick-lead|free\/start)/.test(config.url || "")) config.headers["X-Lead-Attr"] = h;
    return config;
  }));
}
